<div id="invited-users-page" class="body-padding">
  <div class="flex flex-col items-baseline mb-4">
    <h1 id="invited-users-title" class="general-font text-4xl font-bold text-gray-900">Invited Users</h1>
  </div>
  <div class="flex flex-wrap gap-4 items-baseline align-baseline">
    <div class="w-fit mr-3 flex items-end">
      <div>
        <label for="invited-users-search-input" class="block mb-2 text-sm font-medium text-gray-900">Search</label>
        <div id="invited-users-search-container"
             class="flex items-center h-fit border border-gray-300 rounded-lg w-fit bg-gray-50">
          <svg class="ml-2 h-5 w-5 pr-1 text-gray-600" width="15" height="16" viewBox="0 0 15 16" fill="none"
               xmlns="http://www.w3.org/2000/svg">
            <g id="Left Icon">
              <path id="Vector"
                    d="M14.5 15L10.5 11M6.5 13C3.18629 13 0.5 10.3137 0.5 7C0.5 3.68629 3.18629 1 6.5 1C9.81371 1 12.5 3.68629 12.5 7C12.5 10.3137 9.81371 13 6.5 13Z"
                    stroke="#1D1929"/>
            </g>
          </svg>
          <input id="invited-users-search-input" (change)="refreshData()"
                 [(ngModel)]="search" type="text" placeholder="Invited Users Lookup" class="input-custom"/>
        </div>
      </div>
      <button id="invited-users-invite-btn" (click)="togglePopup()" class="navbar-button pr-3 pl-3 ml-2"
              type="button">
        Invite User
      </button>

      @if (isPopupOpened) {
        <div id="invited-users-modal"
             class="overflow-x-auto fixed top-0 right-0 left-0 z-50 flex justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full backdrop-blur-xl">
          <div id="invited-users-modal-dialog" class="relative p-4 w-full max-w-2xl max-h-full">
            <div id="invited-users-modal-content" class="relative bg-white rounded-lg shadow dark:bg-gray-700">
              <div id="invited-users-modal-header"
                   class="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600">
                <h3 id="invited-users-modal-title" class="text-xl font-semibold text-gray-900 dark:text-white">
                  Invite User
                </h3>
                <button id="invited-users-modal-close-btn" type="button" (click)="togglePopup()"
                        class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white">
                  <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                       viewBox="0 0 14 14">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
                  </svg>
                  <span class="sr-only">Close modal</span>
                </button>
              </div>
              @if (isLoaded) {
                <div id="invited-users-modal-body" class="p-4 md:p-5 space-y-4">
                  <form id="invited-users-form" [formGroup]="invitationForm">
                    <div class="mb-3">
                      <label for="invited-users-firstname-input" class="form-input-label">First Name<span
                        class="text-red-600">*</span></label>
                      <input id="invited-users-firstname-input"
                             class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                             placeholder="John" required
                             formControlName="first_name">
                      @if (isInvalidAndTouched('first_name')) {
                        <div id="invited-users-firstname-error"
                             class="flex gap-2 text-xs pt-2 text-red-500">
                          <custom-icon size="14.4px" iconName="fa-triangle-exclamation"/>
                          @if (invitationForm.controls['first_name'].errors?.['required']) {
                            <span>First Name is required.</span>
                          }
                        </div>
                      }
                    </div>
                    <div class="mb-3">
                      <label for="invited-users-lastname-input" class="form-input-label">Last Name<span
                        class="text-red-600">*</span></label>
                      <input id="invited-users-lastname-input"
                             class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                             placeholder="Smith"
                             required
                             formControlName="last_name">
                      @if (isInvalidAndTouched('last_name')) {
                        <div id="invited-users-lastname-error"
                             class="flex gap-2 text-xs pt-2 text-red-500">
                          <custom-icon size="14.4px" iconName="fa-triangle-exclamation"/>
                          @if (invitationForm.controls['last_name'].errors?.['required']) {
                            <span>Last Name is required.</span>
                          }
                        </div>
                      }
                    </div>
                    <div class="mb-3">
                      <label for="invited-users-email-input" class="form-input-label">Work Email<span
                        class="text-red-600">*</span></label>
                      <input id="invited-users-email-input" type="email"
                             class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                             placeholder="name@company.com" autocomplete="false"
                             required
                             formControlName="email">
                      @if (isInvalidAndTouched('email')) {
                        <div id="invited-users-email-error"
                             class="flex gap-2 text-xs pt-2 text-red-500">
                          <custom-icon size="14.4px" iconName="fa-triangle-exclamation"/>
                          @if (invitationForm.controls['email'].errors?.['required']) {
                            <span>Email is required.</span>
                          }
                          @if (invitationForm.controls['email'].errors?.['pattern']) {
                            <span>Email format is invalid.</span>
                          }
                        </div>
                      }
                    </div>
                    <div class="mb-3">
                      <label for="invited-users-phone-input" class="form-input-label">Phone</label>
                      <input id="invited-users-phone-input" type="text"
                             class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                             placeholder="+1 (XXX) XXX-XXXX" formControlName="phone">
                    </div>
                    <div class="mb-3">
                      <label for="invited-users-company-input" class="form-input-label">Company</label>
                      <input id="invited-users-company-input" type="text" [disabled]="true"
                             class="disabled:bg-gray-300 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                             placeholder="Enter your company name"
                             formControlName="company">
                    </div>
                    <div>
                      <label for="invited-users-role-select" class="form-input-label">Role<span
                        class="text-red-600">*</span></label>
                      <ng-select
                        [items]="roles"
                        bindLabel="display_name"
                        notFoundText="No roles found"
                        bindValue="cp_role_id"
                        placeholder="Select role"
                        required class="select-custom"
                        id="invited-users-role-select"
                        formControlName="role">
                        <ng-template ng-label-tmp let-item="item">
                          {{ item.display_name }}
                        </ng-template>
                      </ng-select>
                      @if (isInvalidAndTouched('roles')) {
                        <div id="invited-users-role-error"
                             class="flex gap-2 text-xs pt-2 text-red-500">
                          <custom-icon size="14.4px" iconName="fa-triangle-exclamation"/>
                          @if (invitationForm.controls['roles'].errors?.['required']) {
                            <span>Role is required.</span>
                          }
                        </div>
                      }
                    </div>
                    <div class="flex mt-2">
                      <label for="invited-users-select-all-locations"
                             class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Select All
                        Locations</label>
                      <input formControlName="select_all_location" type="checkbox"
                             id="invited-users-select-all-locations" class="ml-2"/>
                    </div>
                    <div>
                      <label for="invited-users-locations-select" class="form-input-label">Location(s)<span
                        class="text-red-600">*</span></label>
                      <ng-select id="invited-users-locations-select"
                                 required
                                 class="select-custom"
                                 placeholder="Select location(s)"
                                 [multiple]="true"
                                 formControlName="locations">
                        @for (i of locations; track i.location_id; let idx = $index) {
                          <ng-option [value]="i.location_id">
                            <div id="invited-users-location-option-{{idx}}">
                              {{ i.location_name }}
                            </div>
                          </ng-option>
                        }
                      </ng-select>
                      @if (isInvalidAndTouched('locations')) {
                        <div id="invited-users-locations-error"
                             class="flex gap-2 text-xs pt-2 text-red-500">
                          <custom-icon size="14.4px" iconName="fa-triangle-exclamation"/>
                          @if (invitationForm.controls['locations'].errors?.['required']) {
                            <span>Location(s) is required.</span>
                          }
                        </div>
                      }
                    </div>
                  </form>
                </div>
              }
              <div id="invited-users-modal-footer"
                   class="flex items-center justify-end p-4 md:p-5 border-t border-gray-200 rounded-b dark:border-gray-600">
                <button id="invited-users-modal-submit-btn" type="button" (click)="inviteUser()" [disabled]="isInviting"
                        class="navbar-button pr-3 pl-3">
                  Invite
                </button>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
  <div id="invited-users-table-container" class="mt-8">
    <custom-table id="invited-users-table" [columns]="tableColumns" [data]="tableData"
                  primaryDataKey="cp_pending_user_id" [serverPagination]="true" [loading]="loadingTableData()"
                  (paramsChange)="onTableParamChange($event)" emptyDataMessage="No Users matching your filters"/>
  </div>
</div>
